<template>
    <div>
        <!-- 功能按钮 -->
        <buttonlist
                @help="help"
                @add="add"
                @reflash="reflash"
                @del="batchDel"
                ref="SetBtn"
        ></buttonlist>
        <!-- 功能按钮 -->
        <!-- 表格 -->
        <el-table
                id="xpane-0"
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="false"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight"
                @cell-dblclick="editInfo"
                tab-click="selectInfo(0)"
                header-row-class-name="headerclass"
                @selection-change="handleSelectionChange"
                style="width: 100%; margin-top:0px"
                :header-cell-style="$limits.headerClass"
                ref="singleTable"
        >
            <el-table-column type="selection"></el-table-column>
            <el-table-column show-overflow-tooltip prop="id" label="ID" v-if="false"></el-table-column>
            <el-table-column show-overflow-tooltip prop="group_name" :label="$t('getapi[1176]')" width="150"></el-table-column>
            <el-table-column :label="$t('getapi[6048]')" width="80">
                <template slot-scope="scope">
                    <el-button :disabled="!btn.edit" @click.native.prevent="editInfo(scope.row)" type="text"
                               size="small">{{ $t('getapi[34]') }}
                    </el-button>
                    <el-popconfirm
                            :confirmButtonText="$t('getapi[937]')"
                            :cancelButtonText="$t('getapi[6]')"
                            icon="el-icon-info"
                            iconColor="red"
                            :title="$t('getapi[637]')"
                            @onConfirm="del(scope)"
                    >
                        <el-button :disabled="!btn.del" slot="reference" type="text" size="small">{{ $t('getapi[40]')
                            }}
                        </el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <el-row class="page">
            <el-col :span="12">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[50, 100, 200, 300, 400]"
                        :page-size="PageSize"
                        background
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="12">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <el-dialog v-dialogDrag :visible.sync="isVisible" :title="$t('getapi[34]')" width="20%"
                   :close-on-click-modal="false">
            <el-divider></el-divider>
            <div :style="{border:'1px solid #DCDFE6'}">
                <table>
                    <tr>
                        <td>{{$t('getapi[1176]')}}</td>
                        <!--<td>
                            <el-input
                                    v-model="dataList.group_name"
                                    type="text"
                                    readonly
                                    class="mcolor"
                                    size="mini"
                            >
                                <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectGroupName()"></i>
                            </el-input>
                        </td>-->
                        <td><el-input v-model="dataList.group_name"></el-input></td>
                    </tr>
                </table>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
				<el-button @click="isVisible = false" size="mini">{{ $t('getapi[6]') }}</el-button>
				<el-button type="primary" @click="save" :loading="loading"
                           :disabled="loading" size="mini">{{ $t('getapi[937]') }}</el-button>
			</span>
        </el-dialog>

        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Pro/SchPro/GetGroupNamePopupList'" @callback="getGroupName" ref="groupname"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';

    export default {
        name: '2_apsgroup',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                isVisible: false,
                DbTbNames: '', //表名
                userData: [],
                user: "",
                dataSet: [],
                dataList: {},
                PageIndex: 1,
                PageSize: this.$http.getPageSize('2_apsgroup'),
                SelectIndex: 1,
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                queryData: [], // 查询数组
                selectData: [],
                ids: "",
                btn: {
                    del: false,
                    edit: false
                },
                scrollTop:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted() {
            let that = this;
            that.userData = JSON.parse(sessionStorage.getItem('userData'))
            that.user = that.userData.username
            that.getView();
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[12444]"),this.$t("getapi[20]"));
            },
            //按钮操作权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                if(that.selectData.length>0){
                    that.$refs.SetBtn.SetButtonEnable('create,save,refresh,del')
                } else {
                    that.$refs.SetBtn.SetButtonEnable('create,save,refresh')
                }
                that.btnauthority()
            },
            btnauthority(){
                let that = this
                that.btn.edit = true;
                that.btn.del = true;
            },
            //修改页数
            handleSizeChange(val) {
                this.PageSize = val;
                this.$http.savePageSize('2_apsgroup',val)
                this.intidata();
                this.authority();
            },
            //跳页
            handleCurrentChange(val) {
                this.PageIndex = val;
                this.intidata();
                this.authority();
            },
            //编辑
            editInfo(row) {
                let that = this;
                that.isVisible = true
                that.dataList = {
                    id: row.id,
                    group_name: row.group_name,
                }
            },
            // 获取数据
            getView() {
                let that = this;
                that.loading = true;
                let pm = {
                    query_Condition: '',
                    query_field_type: '',
                    query_field_name: ''
                };
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Param: []
                };
                that.queryData.forEach(item => {
                    pm = {
                        query_Condition: item.query_Condition,
                        query_field_type: item.Query_Field_Type,
                        query_field_name: item.Query_Field_Name
                    };
                    parm.Param.push(pm);
                });
                that.$http.urlpost('/Pro/SchPro/GetAllAPSGroupView', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.loading = false;
                    that.authority();
                });
            },
            // 保存数据
            save() {
                let that = this;
                that.loading = true;
                let parm = that.dataList
                that.$http.urlpost('/Pro/SchPro/SaveAPSGroup', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.isVisible = false;
                        that.getView();
                    }
                    that.loading = false;
                });
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectData = val;
                that.authority()
            },
            // 删除
            delf() {
                let that = this;
                let arr = []
                for(let i = 0;i<that.selectData.length;i++){
                    arr = [...arr,{
                        id: that.selectData[i].id
                    }]
                }
                let parm = {
                    list: arr
                };
                that.$http.urlpost('/Pro/SchPro/DelAPSGroupByID', parm, function (res) {
                    that.getView();
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                });
            },
            // 删除
            del(row) {
                let that = this
                let parm = {
                    list: [{
                        id: row.row.id
                    }]
                }
                that.$http.urlpost('/Pro/SchPro/DelAPSGroupByID', parm, function (res) {
                    that.getView();
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                });
            },
            //批量删除
            batchDel() {
                let that = this;
                that.ids = this.selectIDData;
                that.$confirm(that.$t('getapi[8594]'), that.$t('getapi[194]'), {//'此操作将永久删除该数据, 是否继续?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        that.delf();
                    })
                    .catch(() => {
                    });
            },
            // 新增
            add() {
                let that = this
                that.isVisible = true;
                that.dataList = {
                    id: 0,
                    group_name: '',
                }
            },
            // 刷新
            reflash() {
                this.getView();
            },
            selectGroupName(){
                let that = this;
                that.$refs.groupname.clearInput(true);
            },
            getGroupName(val){
                let that = this;
                console.log(val)
                that.dataList.group_name = val.group_name
            },
        }
    };
</script>

<style lang="scss" scoped>
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
